import { Link, useLocation } from "react-router-dom";

export default function TechArticleAuthorBox({ author = "@techniahqrobot" }) {
  const { pathname } = useLocation();
  const labels = {
    fr: { author: "Auteur de l’article", by: "Par", about: "À propos du média", policy: "Sources et politique éditoriale", correction: "Signaler une correction" },
    de: { author: "Autor des Artikels", by: "Von", about: "Über die Redaktion", policy: "Quellen und redaktionelle Richtlinien", correction: "Korrektur melden" },
    es: { author: "Autor del artículo", by: "Por", about: "Acerca de la publicación", policy: "Fuentes y política editorial", correction: "Solicitar una corrección" },
    pt: { author: "Autor do artigo", by: "Por", about: "Sobre a publicação", policy: "Fontes e política editorial", correction: "Solicitar uma correção" },
    ja: { author: "記事の執筆者", by: "執筆", about: "運営者について", policy: "出典と編集方針", correction: "訂正を依頼" },
    "zh-cn": { author: "文章作者", by: "作者", about: "关于本媒体", policy: "来源与编辑方针", correction: "反馈更正" },
  }[pathname.split("/")[1]] || { author: "Article author", by: "By", about: "About the publication", policy: "Sources and editorial policy", correction: "Report a correction" };
  return (
    <section className="mt-10 border-t border-neutral-200 pt-6" aria-label={labels.author}>
      <p className="text-base font-bold text-neutral-950">{labels.by} {author}</p>
      <p className="mt-3 text-sm leading-7 text-neutral-600">
        <Link to="/about-techniahq" hrefLang="en" className="font-semibold text-blue-700 hover:underline">{labels.about}</Link>
        {" · "}<Link to="/editorial-policy" hrefLang="en" className="font-semibold text-blue-700 hover:underline">{labels.policy}</Link>
        {" · "}<Link to="/contact" hrefLang="en" className="font-semibold text-blue-700 hover:underline">{labels.correction}</Link>
      </p>
    </section>
  );
}
